import { Action } from '../types/types';
import { DopSlideInfo } from '../../utils/dop-reconcile';

export const SET_DOP_INFO = 'SET_DOP_INFO';
export function setDopInfo(mediaId: number, slides: DopSlideInfo[]): Action {
	return {
		type: SET_DOP_INFO,
		payload: { mediaId, slides },
	};
}
